<template>
  <div>
    <ExploitantActions
      v-bind="$props"
      :showModalAll="showModalAll"
      :onClickEditer="onClickEditer"
      :onClickRenouvellement="onClickRenouvellement"
    />
    <DrealActions
      v-bind="$props"
      :showModalAll="showModalAll"
      :showEditer="showEditer"
      :onClickEditer="onClickEditer"
      :onClickRenouvellement="onClickRenouvellement"
    />
  </div>
</template>

<script setup>

import ExploitantActions from "@/components/ParcCard/ParcActions/ExploitantActions.vue";
import DrealActions from "@/components/ParcCard/ParcActions/DrealActions.vue";
import {useReactiveStoreGetters, useStoreGetters} from "@/composables/useStore";
import {useModal} from "bootstrap-vue-next";
import {parcService} from "@/service/parc.service";

const {show: showModalAll} = useModal('modal-show-all')
const {show: showEditer} = useModal('modal-editer')
const {show: showRenouvellementList} = useModal('modal-renouvellement-list')
const {show: showRenouvellementForm} = useModal('modal-renouvellement-form')

defineProps({
  isPublishable: Boolean,
})

// Getters
const { parc } = useStoreGetters(['parc']);
const {isRenouvellement} = useReactiveStoreGetters(['isRenouvellement']);

const lock = () => {
  parcService
    .getParcLockById(parc.id)
    .then(data => {
      console.log("parc locké");
      if (data) {
        parc.dateVerrou = data.dateVerrou;
        parc.mailVerrou = data.mailVerrou;
      }
    })
    .catch(err => {
      console.log(err);
    });
};

const onClickRenouvellement = () => {
  lock();
  console.log("isRenouvellement", isRenouvellement.value);
  isRenouvellement.value ? showRenouvellementList() : showRenouvellementForm();
};

const onClickEditer = () => {
  lock();
  showEditer();
};
</script>
